import { useMemo } from 'react';

import { useFieldFacets } from '../../../hooks/queries';
import { ClientDataType } from '../../../types';

type UseFacetOptionsProps = {
  dataType: ClientDataType;
  field: string;
};

export const useFacetOptions = ({ dataType, field }: UseFacetOptionsProps) => {
  const { didError, fieldFacets, isLoading } = useFieldFacets({ dataType, field });
  const options = useMemo(
    () => fieldFacets.map((facet) => ({ title: facet.name, value: facet.id })),
    [fieldFacets],
  );

  return {
    isLoading,
    didError,
    options,
  };
};
